let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1TUXj")).then(() => parcelRequire('4Uyp0'));